import { InstallationContent } from "@/model/data/content/InstallationContent";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class FetchInstallationsContentResponse extends ApiGenericResponse {
    installationsList: InstallationContent[];
    totalInstallationsCount: number;

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationContents && obj.InstallationContents.length > 0) {
            obj.InstallationContents.forEach((e) => {
                let inst = new InstallationContent();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }
        if (obj.TotalInstallationsCount) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
